import React from 'react';
import {
  Button,
  Box,
  Text,
  Popover,
  PopoverTrigger,
  PopoverContent,
  PopoverArrow,
  PopoverBody,
  useDisclosure,
  useBreakpointValue,
} from '@chakra-ui/react';
import LaunchPreviewModal from 'src/components/atoms/launch-preview-modal';

interface LaunchPreviewButtonProps {
  launchPreviewRequested: boolean;
  size?: string;
}

const LaunchPreviewButton = ({ launchPreviewRequested, size = 'sm' }: LaunchPreviewButtonProps) => {
  const { isOpen, onOpen, onClose } = useDisclosure();

  const buttonPadding = useBreakpointValue({ base: 10, sm: 6 });

  const handleButtonClick = () => {
    if (!launchPreviewRequested) {
      onOpen();
    }
  };

  return (
    <>
      {launchPreviewRequested ? (
        <Popover placement="top">
          <PopoverTrigger>
            <Box>
              <Button
                bg="white"
                color="gray.700"
                border="1px solid"
                borderColor="gray.200"
                data-test="launch-preview-btn"
                cursor="default"
                size={size}
                ml={2}
                _hover={{ bg: 'gray.50', borderColor: 'gray.300' }}
                boxShadow="sm"
                fontWeight="medium"
              >
                On Launch Waitlist
              </Button>
            </Box>
          </PopoverTrigger>
          <PopoverContent bg="lomaGreen.50" borderColor="lomaGreen.200" maxW="sm">
            <PopoverArrow bg="lomaGreen.50" />
            <PopoverBody>
              <Text fontSize="sm" color="lomaGreen.900" textAlign="center">
                📧 Look out for an email from Loma letting you know when your site is live!
              </Text>
            </PopoverBody>
          </PopoverContent>
        </Popover>
      ) : (
        <Button
          bg="white"
          color="lomaDarkGreen.900"
          border="1px solid"
          borderColor="lomaGreen.900"
          data-test="launch-preview-btn"
          onClick={handleButtonClick}
          size={size}
          px={buttonPadding}
          ml={2}
          _hover={{
            bg: 'gray.50',
            color: 'lomaDarkGreen.900',
          }}
          boxShadow="lg"
          fontWeight="semibold"
          transition="all 0.2s"
        >
          Ready to Launch?
        </Button>
      )}

      <LaunchPreviewModal
        isOpen={isOpen}
        onClose={onClose}
        launchPreviewRequested={launchPreviewRequested}
      />
    </>
  );
};

export default LaunchPreviewButton;
